import { TextBox, TextBoxComponentSpacing } from './TextBox';

interface ZipCodeBoxProps {
    id?: string;
    dataTestid?: string;
    value: string | undefined;
    name?: string;
    readOnly?: boolean;
    label?: string;
    helperText?: string;
    required?: boolean;
    children?: React.ReactNode;
    width?: string;
    maxLength?: number;
    placeholder?: string;
    onChange: (value: string) => void;
    onEnterKey?: () => void;
    onValidationEvent?: (isValid: boolean) => void;
    componentSpacing?: TextBoxComponentSpacing;
    validator?: React.ReactNode;
    showInfoIcon?: boolean;
    infoText?: string;
}

export const ZipCodeBox: React.FC<ZipCodeBoxProps> = ({
    id,
    dataTestid,
    value,
    readOnly = false,
    label,
    helperText,
    required = false,
    children,
    width = 'auto',
    maxLength,
    placeholder,
    onChange,
    onEnterKey,
    onValidationEvent,
    componentSpacing,
    validator,
    showInfoIcon = false,
    infoText,
}) => {
    const validateValue = (value: string) => {
        const zipPattern = /^\d{5}(-\d{4})?$/;
        return zipPattern.test(value);
    };

    return (
        <TextBox
            id={id}
            dataTestid={dataTestid}
            value={value}
            onEnterKey={onEnterKey}
            readOnly={readOnly}
            onChange={onChange}
            validateValue={validateValue}
            onValidationEvent={onValidationEvent}
            validateValueMessage='Invalid ZIP code'
            label={label}
            helperText={helperText}
            required={required}
            children={children}
            width={width}
            placeholder={placeholder}
            maxLength={maxLength}
            type='tel'
            componentSpacing={componentSpacing}
            validator={validator}
            showInfoIcon={showInfoIcon}
            infoText={infoText}
        />
    );
};
